import React from 'react';
import PropTypes from 'prop-types';
import {useMicroTooltipControls} from './MicroTooltip.utils';
import {ControlButtons, ControlTooltip} from '../../ControlTooltip';

export function MicroTooltip(props) {
  const [controlItems, setControlItems] = React.useState([]);

  const {getControlItems} = useMicroTooltipControls();

  const tooltipStyle = () => {
    let style = {top: '30px'};
    if (props.isOpen) {
      style.top = '-40px';
    }
    return style;
  };

  React.useEffect(() => {
    setControlItems(getControlItems(props));
  }, [props.slots, props.isOpen]);

  return (
    <ControlTooltip
      label='Microcentrifuge'
      showControls={props.showControls}
      tooltipStyle={tooltipStyle()}>
      <ControlButtons buttonList={controlItems} />
    </ControlTooltip>
  );
}

MicroTooltip.propTypes = {
  /**
   * Booolean to set if contols tooltip should be displayed
   */
  showControls: PropTypes.bool,
  /**
   * List of tubes in apparatus with its status.
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Type of Tube placed in slot
       */
      tubeType: PropTypes.string,
      /**
       * boolean to specify if solution placed
       */
      solution: PropTypes.bool,
      /**
       * Boolean to specify if rotor placed
       */
      rotor: PropTypes.bool,
    })
  ),
  /**
   * Boolean to specify if lid Open
   */
  isOpen: PropTypes.bool,
  /**
   * Function to invoke on Clicking config menu
   */
  openShowControlsModal: PropTypes.func,
  /**
   * Function to open/close Lid
   */
  toggleLid: PropTypes.func,
  /**
   * Funciton to eject all tubes
   */
  onEjectTube: PropTypes.func,
  /**
   * Function to eject all rotors
   */
  onEjectRotor: PropTypes.func,
  /**
   * Function to open Balance Solution Modal
   */
  openBalanceModal: PropTypes.func,
};

MicroTooltip.defaultProps = {
  showControls: false,
};
